import Configs from '@/Configs';

import { HRBP_MODULE_ACCESS_ALL } from '@/constants/hrbpRouteModuleCodes';

/**
 * When a route lists HRBP among `allowedRoles`, optionally pass `hrbpModuleCode` so users who only
 * have the HRBP **numeric** role (not real HR/Exec) are denied unless their HRBP grant includes
 * that module or {@link HRBP_MODULE_ACCESS_ALL}.
 *
 * Users who already match `allowedRoles` via Manager / HR / Exec / IC / … are not blocked.
 *
 * @param {object} params
 * @param {number[]} params.allowedRolesArray
 * @param {number[]} params.securityLevelArray
 * @param {string | null | undefined} params.hrbpModuleCode
 * @param {string[] | null | undefined} params.hrbpModuleAccess from profile (`hrbpModuleAccess`)
 * @returns {boolean} true → redirect to unauthorized
 */
export function isDeniedByHrbpModuleGate(params: {
  allowedRolesArray: number[];
  securityLevelArray: number[];
  hrbpModuleCode?: string | null;
  hrbpModuleAccess?: string[] | null;
}): boolean {
  const { allowedRolesArray, securityLevelArray, hrbpModuleCode, hrbpModuleAccess } = params;

  if (!hrbpModuleCode) {
    return false;
  }

  if (!allowedRolesArray.includes(Configs.securityLevelHRBP)) {
    return false;
  }

  if (!securityLevelArray.includes(Configs.securityLevelHRBP)) {
    return false;
  }

  const hasNonHrbpRoleMatch = allowedRolesArray.some((level) => {
    if (level === Configs.securityLevelHRBP) {
      return false;
    }
    return securityLevelArray.includes(level);
  });

  if (hasNonHrbpRoleMatch) {
    return false;
  }

  if (securityLevelArray.includes(Configs.securityLevelHR)) {
    return false;
  }

  if (securityLevelArray.includes(Configs.securityLevelExec)) {
    return false;
  }

  if (!hrbpModuleAccess || !Array.isArray(hrbpModuleAccess) || hrbpModuleAccess.length === 0) {
    return true;
  }

  if (hrbpModuleAccess.includes(HRBP_MODULE_ACCESS_ALL)) {
    return false;
  }

  return !hrbpModuleAccess.includes(hrbpModuleCode);
}
